import { createI18n } from 'vue-i18n'
import en from './en'
import no from './no'

export const i18n = createI18n({
  legacy: false, // Set to false to use Composition API
  locale: 'no', // Default language
  fallbackLocale: 'en',
  messages: {
    en,
    no,
  },
})

// Helper function to change locale
export const setLocale = (locale: 'no' | 'en') => {
  i18n.global.locale.value = locale
  // Optionally save to localStorage for persistence
  localStorage.setItem('userLanguage', locale)
}

// Helper function to get current locale
export const getCurrentLocale = () => i18n.global.locale.value
